import { createAction } from '@reduxjs/toolkit';

import type {
  MessageHandlerResult,
  MessageStats,
} from '@/services/abstract/poc/MessagingService';

export interface IncomingMessagePayload {
  result: MessageHandlerResult;
  stats: MessageStats;
}

export const incomingMessageReceived = createAction<IncomingMessagePayload>(
  'messaging/incomingMessageReceived'
);
